import type { EventCallback, EventName } from "@tauri-apps/api/event";
import { invoke } from "@tauri-apps/api/core";
import { emit, listen } from "@tauri-apps/api/event";
import type { Tauri } from ".";

export class RealTauri implements Tauri {
  get enabled(): boolean {
    return true;
  }

  invoke<T>(command: string, args?: Record<string, any>): Promise<T> {
    return invoke<T>(command, args);
  }

  emit(event: string, data: any) {
    emit(event, data);
  }

  listen<Event>(event: EventName, callback: EventCallback<Event>) {
    return listen<Event>(event, callback) as Promise<() => void>;
  }

  async checkUpdate(channel?: "beta" | "release") {
    // Use the Rust command instead of the plugin's check() method
    // This allows us to get release info even when no update is available
    return await this.invoke<{
      shouldUpdate: boolean;
      manifest: {
        version: string;
        date: string | null;
        body: string | null;
      };
    }>("check_for_updates", channel ? { channel } : undefined);
  }

  async getUpdateForChannel(channel: "beta" | "release"): Promise<boolean> {
    return await this.invoke<boolean>("get_update_for_channel", { channel });
  }

  async downloadUpdateForLater(channel: "beta" | "release"): Promise<void> {
    return await this.invoke("download_update_for_later", { channel });
  }

  async installCachedUpdate(): Promise<boolean> {
    return await this.invoke<boolean>("install_cached_update");
  }

  async downloadAndInstallUpdate(channel: "beta" | "release"): Promise<void> {
    return await this.invoke("download_and_install_update", { channel });
  }

  async getUpdateChannel(): Promise<"beta" | "release"> {
    return await this.invoke<"beta" | "release">("get_update_channel");
  }

  async setUpdateChannel(channel: "beta" | "release"): Promise<void> {
    return await this.invoke("set_update_channel", { channel });
  }

  performSync() {
    return this.invoke("perform_sync");
  }

  getCloseToTrayEnabled(): Promise<boolean> {
    return this.invoke<boolean>("get_close_to_tray_enabled");
  }

  setCloseToTrayEnabled(enabled: boolean): Promise<void> {
    return this.invoke("set_close_to_tray_enabled", { enabled });
  }
}
